module.exports = require("core-js-pure/features/instance/slice");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js/instance/slice.js
// module id = 616
// module chunks = 0